import { render } from "./gaji-periode.vue?vue&type=template&id=026a52a4&scoped=true"
import script from "./gaji-periode.vue?vue&type=script&lang=js"
export * from "./gaji-periode.vue?vue&type=script&lang=js"

import "./gaji-periode.vue?vue&type=style&index=0&id=026a52a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026a52a4"]])

export default __exports__